import { writable } from 'svelte/store'
import type { ActiveRoute } from '$classes/Router'

export const mainRouterParams = writable<ActiveRoute>({
    path: '/',
    pathParts: [],
    params: {},
    query: {},
    previousPath: null
})

export function setMainRouterParams(activeRoute: ActiveRoute) {
    mainRouterParams.set(activeRoute)
}
